import { render } from "./PluginBox.vue?vue&type=template&id=c6265cd0"
import script from "./PluginBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginBox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PluginBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6265cd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6265cd0', __exports__)) {
    api.reload('c6265cd0', __exports__)
  }
  
  module.hot.accept("./PluginBox.vue?vue&type=template&id=c6265cd0", () => {
    api.rerender('c6265cd0', render)
  })

}


export default __exports__